import { ReactNode, useEffect, useRef, useState } from "react";
import { useGetMyCompaniesQuery } from "../../API/authApi";
import moment from "moment";
import { useExprationHook, useGeneralHooks } from "../../Hooks/hooks";
import useDialogHooks from "../../Components/Dialog/dialog-hooks";
import ExpirationDialog from "../../Components/Dialog/DialogContents/ExpirationDialog/expirationDialog";
import { ExpirationTypes } from "../../Interfaces/componentTypes";

const useBusinessDashboardHooks = () => {
    const { navigate, t } = useGeneralHooks();
    const { data, isLoading } = useGetMyCompaniesQuery();
    const myCompanies = data ?? [];
    const company = data ? myCompanies[0] : undefined;
    const { open: isDialogOpen, onOpen, onClose: onCloseDialog } = useDialogHooks();
    const [dialogComponent, setDialogComponent] = useState<ReactNode | null>(null)
    const hasCheckedExpiration = useRef(false);
    const { demoStatus,demoDaysLeft,paidStatus,paidDaysAfter,paidDaysLeft} = useExprationHook(company)

    useEffect(() => {
        if (!company || hasCheckedExpiration.current) return; 

        if (company.demo_version && demoStatus !== "active") {
            console.log("Open demo version dialog");
            setDialogComponent(
                <ExpirationDialog
                    type={ExpirationTypes.DEMO}
                    onClose={onCloseDialog}
                    daysLeft={demoDaysLeft!}
                />
            );
            onOpen();
            hasCheckedExpiration.current = true;
        } else if (!company.demo_version && paidStatus !== "active") {
            // Open Paid Version dialog
            setDialogComponent(
                <ExpirationDialog
                    type={ExpirationTypes.PAID}
                    onClose={onCloseDialog}
                    daysLeft={paidDaysLeft!}
                    daysAfter={paidDaysAfter!}
                />
            );
            onOpen();
            hasCheckedExpiration.current = true;
        }
    }, [company, demoStatus, paidStatus]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    return {
        t,
        myCompanies,
        isLoading,
        company,
        demoDaysLeft,
        demoStatus,
        paidDaysLeft,
        paidDaysAfter,
        paidStatus,
        isDialogOpen,
        dialogComponent,
        navigate,
        onCloseDialog,
    };
};

export default useBusinessDashboardHooks;
